import {useEffect, useState} from "react";
import {useLocation, useNavigate, useSearchParams} from "react-router-dom";
import "./style.scss";

const InputFilter = ({data, className, isOnModal, filterParam, changeFilterParam, searchStatus, setSearchStatus}) => {
    const {key, label, placeholder} = data;
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams();
    const defaultFilter = searchParams.get(key);
    const [InputValue, setInputValue] = useState();
    const {pathname} = useLocation()

    useEffect(() => {
        setInputValue(defaultFilter)
    }, []);

    useEffect(() => {
        if (isOnModal) {
            changeFilterParam(key, InputValue)
        } else if (typeof InputValue !== "undefined") setValueToUrl()
    }, [InputValue])

    useEffect(() => {
        if (searchStatus) {
            setValueToUrlOnModal()
            setSearchStatus(false)
        }
        if (pathname !== "/products" && searchParams?.size > 0) {
            navigate(`/products?${searchParams.toString()}`, {replace: true})
        }
    }, [searchStatus, searchParams]);

    const setValueToUrl = () => {
        let newParamsQuery = new URLSearchParams(searchParams);
        if (InputValue !== null && typeof InputValue !== "undefined") newParamsQuery.set(key, InputValue);
        else newParamsQuery.delete(key);
        setSearchParams(newParamsQuery, {replace: false});
    }

    const setValueToUrlOnModal = () => {
        let newParamsQuery = new URLSearchParams(searchParams);
        if (filterParam?.length > 0) filterParam.forEach(item => {
            if (item === "") {
                newParamsQuery.delete(item);
            } else newParamsQuery.set(key, item);
        })
        setSearchParams(newParamsQuery, {replace: true});
    }

    const updateInputFilter = (value) => {
        setInputValue(value);

        let newParamsQuery = new URLSearchParams(searchParams);
        if (newParamsQuery.get("page")) {
            newParamsQuery.delete("page");
            setSearchParams(newParamsQuery);
        }
    }

    return (
        <section className={`input-filter ${className}`}>
            <h6 className="title mr-1 my-auto">
                {label}
            </h6>
            <input
                value={InputValue}
                onChange={(e) =>updateInputFilter(e.target.value)}
                className='form-control'
                name={key}
                id={key}
                placeholder={placeholder}
            />
        </section>
    );
}

export default InputFilter;
